//主页面
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');

//出库明细详情
const inAndOutStoreList = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/productionCenter/inAndOutStore/list.vue');

const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'inAndOutStoreList',
      name: 'inAndOutStoreList',
      component: inAndOutStoreList,
      meta: {
        keepAlive: true,
        title: '成品进出存明细',
      },
    },
    // {
    //   path: 'rawDataAdd',
    //   name: 'rawDataAdd',
    //   component: rawDataAdd,
    //   meta: {
    //     keepAlive: true,
    //     title: '成品出库新增'
    //   }
    // }
  ],
};
export default productionRouter;
